import {
  IconNameEnum,
  useCfarStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";

import { AirCfarExerciseGenericActionView } from "../AirCfarExerciseGenericActionView";
import defaultStyles from "./AirCfarExerciseComplete.module.scss";

export interface AirCfarExerciseCompleteProps {
  email: string;
  onDoneClick: () => void;
}

export const AirCfarExerciseComplete = (
  props: AirCfarExerciseCompleteProps
) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseComplete,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseComplete
  );
  const { t } = useI18nContext();

  const { onDoneClick } = props;

  return (
    <div className={block}>
      <AirCfarExerciseGenericActionView
        title={t("core-flights-cfar.exercise.complete.title")}
        description={
          <Trans
            i18nKey="core-flights-cfar.exercise.complete.descriptionV2"
            values={{
              email: props.email,
            }}
          />
        }
        headerIcon={
          <Icon className={cn("header-icon")} iconName={IconNameEnum.check} />
        }
        footerButtons={[
          <button className={cn("done-button")} onClick={onDoneClick}>
            {t("core-flights-cfar.exercise.complete.done")}
          </button>,
        ]}
      />
    </div>
  );
};
